<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCoreStore } from '@/stores';
import { computed, PropType } from 'vue';
import { ISelectItem } from '../../../stores/core/models';
import { dropdownPreset } from '../../../presets/customizations/dropdown';

const modelValue = defineModel<string | number>();

const props = defineProps({
  placeholder: {
    type: String,
  },
  label: {
    type: String,
  },
  options: {
    type: Array as PropType<(ISelectItem | any)[]>,
  },
  optionLabel: {
    type: String,
    default: 'label',
  },
  optionValue: {
    type: String,
    default: 'key',
  },
  isRequired: {
    type: Boolean,
  },
  permission: {
    type: String,
  },
  useSmallRounding: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const id = 'id' + Math.random().toString(16).slice(2);

const hasPermission = computed(() => {
  return props.permission ? useCoreStore().hasPermission(props.permission).value : true;
});

const isDisabled = computed(() => {
  return !hasPermission.value; // || props.disabled;
});
</script>

<template>
  <div
    class="flex flex-col"
    v-tooltip.bottom="{ value: !hasPermission ? t('core.notAllowedDueMissingPermission') : undefined }"
  >
    <label class="min-w-[150px] text-[14px] pt-1 pb-1 text-gray-700 dark:text-slate-400 !font-medium" :for="id" v-if="props.label"
      >{{ $t(props.label) }}<span v-if="props.isRequired">*</span>
    </label>
    <Select
      :id="id"
      v-model="modelValue"
      :options="props.options"
      :option-label="props.optionLabel"
      :option-value="props.optionValue"
      :placeholder="props.placeholder"
      class="w-full min-w-full"
      :disabled="isDisabled"
      :ptOptions="{ mergeSections: true, mergeProps: true }"
      :pt="{
        ...dropdownPreset,
        root: {
          class: ['!rounded-[14px]', '!ring-0', props.useSmallRounding ? '!rounded-[6px]' : ''],
        },
        dropdown: {
          class: ['!rounded-[14px]'],
        },
        label: {
          class: ['!py-2 text-sm'],
        },
      }"
    />
  </div>
</template>
